module.exports = __webpack_public_path__ + "static/media/ray-anderson-logo 1.d4e2d0ac.png";